export const MARKETING_EVENTS = {
    FORM_SUBMIT: 'form_submit',
};
